import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ner-enum",
  "use": "ner-enum-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"ner-enum\"><path stroke=\"currentColor\" stroke-linejoin=\"round\" d=\"m7 1 2 2-2 2-2-2zM7 9l2 2-2 2-2-2zM11 5l2 2-2 2-2-2zM3 5l2 2-2 2-2-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol